import React from 'react';
import styles from './MarketplaceSection.module.scss';
import LineChartComponent from 'components/charts/line-chart/LineChart';
import BarChartComponent from 'components/charts/barchart/BarChart';
import { useTranslation } from 'react-i18next';

const MarketplaceSection = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.marketplaceSection}>
        {/* Left Side Content */}
        <div className={styles.leftContent}>
          <h1>{t('marketPlaceHeading')}</h1>
          <p>{t('marketPlaceText')}</p>
        </div>

        {/* Right Side Content */}
        <div className={styles.rightContent}>
          {/* Graph 1: Rate of Carbon Offsets */}

          <div className={styles.graphContainer}>
            <h4>{t('lineChartHeading')}</h4>
            <LineChartComponent />
          </div>

          {/* Graph 2: Green Projects Selling Rate */}
          <div className={styles.graphContainer}>
            <h4>{t('barChartHeading')}</h4>
            <BarChartComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketplaceSection;
